function componentHeroVideo(){
  const heroVideo = document.querySelector('.banner__media.media video');
  const heroVideoSrc = heroVideo.querySelector('source').src;
  const appleExpression = /Apple/i;
  const safariExpression = /Safari/i;
  const isAppleSafari = () => {
    return appleExpression.test(navigator.vendor) &&
      safariExpression.test(navigator.userAgent);
  };

  if (isAppleSafari()) {
    heroVideo.outerHTML =
      `<img src="${heroVideoSrc}" alt="Banner Image" class="banner__media media">`;
  }
}

componentHeroVideo();

